<ng-container #ref></ng-container>

<div class="cmps-event-centre-c-pop-dialog--btn-left cmps-cdk-pos-absolute">
    <button
        cmpsIconButton
        (click)="_onLeftClick()"
        *ngIf="_ctx?.multiple"
    >
        <cmps-icon
            class="cmps-cdk-bg-color-black"
            svgIcon="chevron-left"
        ></cmps-icon>
    </button>
</div>

<div class="cmps-event-centre-c-pop-dialog--btn-right cmps-cdk-pos-absolute">
    <button
        cmpsIconButton
        (click)="_onRightClick()"
        *ngIf="_ctx?.multiple"
    >
        <cmps-icon
            class="cmps-cdk-bg-color-black"
            svgIcon="chevron-right"
        ></cmps-icon>
    </button>
</div>
